export default __webpack_public_path__ + "static/media/polaroid38.1379ba98.jpg";